import React from "react";
import { Link } from "react-router-dom";
import { BRAND } from "../lib/brand";

export default function Logo({ size = 40, withText = true, className = "", to = "/" }) {
  const content = (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      <img
        src={BRAND.logoUrl}
        alt="FicoPilot"
        width={size}
        height={size}
        className="rounded-xl select-none"
        draggable={false}
        data-testid="brand-logo"
      />
      {withText && (
        <span className="font-display font-black tracking-tight text-lg sm:text-xl">
          <span className="text-white">Fico</span>
          <span className="text-neon">Pilot</span>
        </span>
      )}
    </span>
  );
  if (to) {
    return (
      <Link to={to} data-testid="brand-logo-link" className="focus:outline-none">
        {content}
      </Link>
    );
  }
  return content;
}
